/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Charter_DescInputs */

const es_nav_m_charter_desc = /** @type {(inputs: Nav_M_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 6ª, la comisión más baja`)
};

const gl_nav_m_charter_desc = /** @type {(inputs: Nav_M_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 6ª, a comisión máis baixa`)
};

const en_nav_m_charter_desc = /** @type {(inputs: Nav_M_Charter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List 6 — lowest commission`)
};

/**
* | output |
* | --- |
* | "List 6 — lowest commission" |
*
* @param {Nav_M_Charter_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_charter_desc = /** @type {((inputs?: Nav_M_Charter_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Charter_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_charter_desc(inputs)
	if (locale === "en") return en_nav_m_charter_desc(inputs)
	return es_nav_m_charter_desc(inputs)
});